import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Divider,
  Badge
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useEffect, useState } from 'react';
import { usePending } from '../context/PendingContext';
// import axios from "../api/axios";

export default function Layout({ children }) {

  const { pendingToDo } = usePending();
  const user_id = localStorage.getItem('user_id');
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  // const [pendingToDo, setPendingToDo] = useState(0);
  const isMobile = useMediaQuery('(max-width:576px)');
  const role = localStorage.getItem("role");

  // useEffect(async () => {
  //   // await axios.get("/pendingItem", payload);
  //   const res = await axios.get('/pendingItem', {user_id});
  //   console.log("res", res.data.pending_to_do)
  //   setPendingToDo(res.data.pending_to_do);
  //   // localStorage.setItem('pending_to_do', res.data.pending_to_do);
  // }, [])

  // useEffect(() => {
  //   // 定義一個內部的 async 函數
  //   const fetchPendingItems = async () => {
  //     try {
  //       // GET 請求的 params 寫法
  //       const res = await axios.get('/pendingItem', {
  //         params: { user_id }
  //       });

  //       setPendingToDo(res.data.pending_to_do);
  //     } catch (error) {
  //       console.error("Fetch pending items failed:", error);
  //     }
  //   };

  //   if (user_id) {
  //     fetchPendingItems();
  //   }
  // }, [user_id]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    // localStorage.removeItem('pending_to_do');
    navigate('/');
  };

  const navItems = [
    { text: '地盤', to: '/sites', role: ["admin", "staff_level_2", "staff_level_1"] },
    { text: '用戶', to: '/users', role: ["admin"] },
    { text: '公司', to: '/companies', role: ["admin"] },
    { text: '貨物', to: '/products', role: ["admin"] },
    { text: '賣貨', to: '/sales', role: ["admin", "staff_level_2"] },
    { text: '貨物進出紀錄', to: '/transfers', role: ["admin", "staff_level_2"] },
  ];

  const renderButton = (item) => {
    if (item.text === "貨物進出紀錄" && pendingToDo != 0) {
      return (
        <Badge color="error" badgeContent={pendingToDo}>
          <Button key={item.text} color="inherit" component={Link} to={item.to}>
            {item.text}
          </Button>
        </Badge>
      )
    } else {
      return (
        <Button key={item.text} color="inherit" component={Link} to={item.to}>
          {item.text}
        </Button>
      )
    }
  }

  const renderListItem = (item) => {
    if (item.text === "貨物進出紀錄" && pendingToDo != 0) {
      return (
        <ListItem button key={item.text} component={Link} to={item.to} sx={{ color: 'black' }} fullWidth>
          <Badge color="error" badgeContent={pendingToDo}>
            <ListItemText primary={item.text} />
          </Badge>
        </ListItem>
      )
    } else {
      return (
        <ListItem button key={item.text} component={Link} to={item.to} sx={{ color: 'black' }} fullWidth>
          <ListItemText primary={item.text} />
        </ListItem>
      )
    }
  }

  return (
    <Box>
      <AppBar position="static">
        <Toolbar>
          {isMobile && (
            <IconButton color="inherit" onClick={() => setDrawerOpen(true)} edge="start" sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
          )}

          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            KMK地盤貨物倉存管理系統 v1.2.30
          </Typography>

          {!isMobile && (
            <>
              {navItems.map((item) => (
                <div>
                  {item.role.includes(role) && renderButton(item)
                  }
                </div>
              ))}
              <Button variant="outlined" color="inherit" onClick={handleLogout} sx={{ ml: 2 }}>
                登出
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        ModalProps={{ keepMounted: true }}
      >
        <Box sx={{ width: 250 }} role="presentation">
          <Box sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
            <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: 'black' }}>
              <ArrowBackIcon />
            </IconButton>
            {/* <Typography variant="subtitle1" sx={{ ml: 1, color: 'black' }}>
              選單
            </Typography> */}
          </Box>
          <Divider />
          <List>
            {navItems.map((item) => (
              <div>
                {item.role.includes(role) &&
                  renderListItem(item)
                }
              </div>
            ))}
            <ListItem button onClick={handleLogout} sx={{ color: 'black' }}>
              <ListItemText primary="登出" />
            </ListItem>
          </List>
        </Box>
      </Drawer>

      <Box sx={{ padding: 2 }}>{children}</Box>
    </Box>
  );
}
